// extracted by mini-css-extract-plugin
export default {"list":"styles_list__N4jPt","item":"styles_item__+jtpy"};